import { atom, selector } from "recoil";

export const ACCOUNT_TYPE = {
  ADMIN: 0,
  RATER: 1,
  APPLICANT: 2,
};

export const authState = atom({
  key: "auth",
  default: JSON.parse(localStorage.getItem("authInfo")),
});

export const testRoomSnState = atom({
  key: "testRoomSnState",
  default: "",
});
